export enum FrequenceEnum {
  ANNUEL = 'ANNUEL',
  BIMENSUEL = 'BIMENSUEL',
  MENSUEL = 'MENSUEL',
  AUX_DEUX_SEMAINES = 'AUX_DEUX_SEMAINES',
  BIHEBDO = 'BIHEBDO',
  HEBDO = 'HEBDO',
  HEBDOMADAIRE = 'HEBDOMADAIRE'
}

export interface FrequenceConfig {
  label: string;
  value: FrequenceEnum;
}

export const FREQUENCES: Record<FrequenceEnum, FrequenceConfig> = {
  [FrequenceEnum.ANNUEL]: {
    label: 'label-frequences.annuel',
    value: FrequenceEnum.ANNUEL
  },
  [FrequenceEnum.BIMENSUEL]: {
    label: 'label-frequences.bimensuel',
    value: FrequenceEnum.BIMENSUEL
  },
  [FrequenceEnum.MENSUEL]: {
    label: 'label-frequences.mensuel',
    value: FrequenceEnum.MENSUEL
  },
  [FrequenceEnum.AUX_DEUX_SEMAINES]: {
    label: 'label-frequences.aux-deux-semaines',
    value: FrequenceEnum.AUX_DEUX_SEMAINES
  },
  [FrequenceEnum.BIHEBDO]: {
    label: 'label-frequences.bihebdo',
    value: FrequenceEnum.BIHEBDO
  },
  [FrequenceEnum.HEBDO]: {
    label: 'label-frequences.hebdo',
    value: FrequenceEnum.HEBDO
  },
  [FrequenceEnum.HEBDOMADAIRE]: {
    label: 'label-frequences.hebdomadaire',
    value: FrequenceEnum.HEBDOMADAIRE
  }
};

export const FREQUENCES_PER_MONTH_ONLY = [FREQUENCES[FrequenceEnum.MENSUEL]];
export const FREQUENCES_PER_YEAR_ONLY = [FREQUENCES[FrequenceEnum.ANNUEL]];
